// client/src/pages/PrivacyPolicy/PrivacyPolicy.style.js
import styled from '@emotion/styled';

export const PrivacyPolicyContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 900px;
  background: linear-gradient(135deg, rgba(165, 80, 255, 1) 0%, rgba(118, 72, 200, 1) 100%);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow-y: auto;
`;

export const PrivacyPolicyCard = styled.div`
  width: 100%;
  height: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    max-width: 80%;
    height: 100%;
    border-radius: 12px;
  }
`;

export const Header = styled.div`
  padding: 40px 48px 32px 48px;
  border-bottom: 2px solid #e5e7eb;
  
  @media (max-width: 768px) {
    padding: 32px 24px 24px 24px;
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-bottom: 16px;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;

export const Title = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  margin: 0 0 8px 0;
  
  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

export const EffectiveDate = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin: 0;
`;

export const Content = styled.div`
  padding: 32px 48px;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 24px 24px;
    max-height: calc(100vh - 280px);
  }
`;

export const Section = styled.section`
  margin-bottom: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h2`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`;

export const SubSection = styled.div`
  margin-top: 20px;
  
  &:first-of-type {
    margin-top: 16px;
  }
`;

export const SubSectionTitle = styled.h3`
  color: #444444;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
`;

export const Paragraph = styled.p`
  color: #555555;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  margin: 0 0 12px 0;
  
  strong {
    color: #333333;
    font-weight: 600;
  }
`;
export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 12px 0;
`;

export const NumberedList = styled.ol`
  padding-left: 24px;
  margin: 12px 0;
`;
export const ListItem = styled.li`
  color: #555555;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 8px;
  padding-left: 16px;
  position: relative;
  
  &:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #6A42F2;
    font-weight: 700;
  }
  
  strong {
    color: #333333;
    font-weight: 600;
  }
`;

export const InfoBox = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
`;

export const InfoBoxTitle = styled.h4`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 16px 0;
`;

export const InfoBoxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoRow = styled.div`
  display: flex;
  gap: 12px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const InfoLabel = styled.div`
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  min-width: 80px;
  flex-shrink: 0;
`;

export const InfoValue = styled.div`
  color: #555555;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  flex: 1;
`;

export const WarningBox = styled.div`
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 6px;
  padding: 12px 16px;
  margin: 12px 0;
  color: #856404;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

export const ContactBox = styled.div`
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  margin: 16px 0;
`;

export const ContactTitle = styled.h4`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContactRow = styled.div`
  display: flex;
  gap: 12px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const ContactLabel = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  min-width: 80px;
  flex-shrink: 0;
`;

export const ContactValue = styled.div`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  flex: 1;
`;

export const ExternalLink = styled.a`
  color: #6A42F2;
  text-decoration: none;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const Footer = styled.div`
  padding: 24px 48px;
  border-top: 2px solid #e5e7eb;
  display: flex;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 20px 24px;
  }
`;

export const FooterButton = styled.button`
  width: 200px;
  height: 48px;
  border-radius: 8px;
  background: #6A42F2;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.9;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;